<template>
	<div>
	<v-dialog v-model="editDialog" max-width="1200px" @input="handleDialogClose">
		<v-card text>
			<v-card-text>
				<v-form ref="form" v-model="valid" lazy-validation>
					<v-stepper v-model="e1">
						<v-stepper-header>
							<v-stepper-step :complete="e1 > 1" step="1" :rules="[() => !errors.has('organizationName') && !errors.has('organizationCode') && !errors.has('organizationType') && !errors.has('identificationDocumentID') && !errors.has('address') && !errors.has('postalCode') ]">Organization Details</v-stepper-step>
							<v-divider></v-divider>
							<v-stepper-step :complete="e1 == 2" step="2" :rules="[() => !errors.has('accountNumber') && !errors.has('accountName') && !errors.has('bankName') && !errors.has('bankSwiftCode') && !errors.has('currency') ]"><span v-if="organisation.organisationTypeId == 4 || organisation.organisationTypeId == 1 || organisation.organisationTypeId == 2 || organisation.organisationTypeId == 3 || organisation.organisationTypeId == 5 || organisation.organisationTypeId == 11">Non-checkoff</span> Settlement Details</v-stepper-step>
							<v-divider></v-divider>
							<v-stepper-step :complete="e1 == 3" step="3" :rules="[() => !errors.has('accountNumber') && !errors.has('accountName') && !errors.has('bankName') && !errors.has('bankSwiftCode') && !errors.has('currency') ]" v-if="organisation.organisationTypeId == 4 || organisation.organisationTypeId == 1 || organisation.organisationTypeId == 2 || organisation.organisationTypeId == 3 || organisation.organisationTypeId == 5 || organisation.organisationTypeId == 11">Checkoff Settlement Details</v-stepper-step>
							<v-divider></v-divider>
							<v-stepper-step :complete="e1 == 4" step="4" :rules="[() => !errors.has('accountNumber') && !errors.has('accountName') && !errors.has('bankName') && !errors.has('bankSwiftCode') && !errors.has('currency') ]" v-if="organisation.organisationTypeId == 4 ">Farmer Usd Account Details</v-stepper-step>
							<v-divider></v-divider>
							<v-stepper-step :complete="e1 == 5" step="5" :rules="[() => !errors.has('accountNumber') && !errors.has('accountName') && !errors.has('bankName') && !errors.has('bankSwiftCode') && !errors.has('currency') ]" v-if="organisation.organisationTypeId == 4 ">Farmer Kes Account Details</v-stepper-step>
						</v-stepper-header>
						<v-stepper-items>
							<v-stepper-content step="1">
								<!-- Step 1: Organization Details -->
								<v-row>
									<v-col cols="12" md="6">
										<v-text-field
											name="organizationName"
											label="Name"
											v-model="organisation.organisationName"
											:rules="organizationNameRules"
											required>
										</v-text-field>
									</v-col>
									<v-col cols="12" md="6">
										<v-text-field
											name="organizationCode"
											label="Code"
											v-model="organisation.organisationCode"
											:rules="organizationCodeRules"
											readonly
											required>
										</v-text-field>
									</v-col>
								</v-row>
								<v-row>
									<v-col cols="12" md="3">
										<v-autocomplete
											v-model="organisation.organisationTypeId"
											:items="institutionTypes"
											item-text="name"
											item-value='id'
											label="Organization Type"
										>
										</v-autocomplete>
									</v-col>
									<v-col cols="12" md="2">
										<v-flex xs12 sm2 v-if="organisation.organisationTypeId == 4 && showCheckbox">
											<v-checkbox
												v-model="isChild"
												label="Child Org?"
											></v-checkbox>
										</v-flex>
									</v-col>
									<v-col cols="12" md="4" v-if="isChild">
										<v-autocomplete
											v-model="selectedParentOrganisation"
											:items="farmersocieties"
											item-text="organisationName"
											item-value="id"
											return-object
											@input="onParentSelect"
											@update:search-input="searchParentOrganisation"
											label="Parent Organisation"
											dense
											clearable
											outlined
											:loading="loading"
										/>
									</v-col>
									<v-col cols="12" md="3">
										<v-text-field
											name="identificationDocumentID"
											label="Identification Document ID"
											v-model="organisation.identificationDocumentID"
											:rules="identificationDocumentIDRules"
											required>
										</v-text-field>
									</v-col>
								</v-row>
								<v-layout wrap v-if="organisation.organisationTypeId == 4 || organisation.organisationTypeId == 11">
									<v-flex xs12 sm4>
										<v-autocomplete
											name="miller"
											v-model="organisation.millerId"
											:items="millers"
											item-text="name"
											item-value='id'
											label="Miller"
											v-validate="'required'"
											:error-messages="errors.collect('millerId')">
										</v-autocomplete>
									</v-flex>
									<v-flex xs12 sm4>
										<v-autocomplete
											name="warehouse"
											v-model="organisation.warehouseId"
											:items="warehouse"
											item-text="name"
											item-value='id'
											label="Warehouse"
											v-validate="'required'"
											:error-messages="errors.collect('warehouseId')">
										</v-autocomplete>
									</v-flex>
									<v-flex xs12 sm4>
										<v-autocomplete
											name="tax"
											v-model="organisation.tax"
											:items="taxtypes"
											item-text="name"
											item-value='id'
											label="Tax Type"
											:error-messages="errors.collect('tax')">
										</v-autocomplete>
									</v-flex>
								</v-layout>
								<v-layout wrap v-if="organisation.organisationTypeId == 12">
									<v-btn color="primary" @click="addLiabilityProviderLoan" rounded>Add Loan</v-btn>
								</v-layout>
								<div v-if="organisation.organisationTypeId == 12">
									<v-layout v-for="(organisation, index) in liabilityProviderLoans" :key="index" wrap >
										<v-col cols="12" md="4">
											<v-text-field
												:name="'loanName_' + index"
												label="Loan Name"
												v-model="organisation.loanName">
											</v-text-field>
										</v-col>
										<v-col cols="12" md="4">
											<v-text-field
												:name="'loanDisburseAccount_' + index"
												label="Disburse Account"
												v-model="organisation.loanDisburseAccount">
											</v-text-field>
										</v-col>
										<v-col cols="12" md="3">
											<v-text-field
												:name="'loanRecoveryAccount_' + index"
												label="Recovery Account"
												v-model="organisation.loanRecoveryAccount">
											</v-text-field>
										</v-col>
										<v-col cols="12" md="1">
											<v-icon class="tight-icon"
													slot="prependIcon"
													@click="removeLiabilityProviderLoan(index)"
													medium color="#666666"
											>fas fa-times</v-icon
											>
										</v-col>
									</v-layout>
								</div>
								<v-row>
									<v-col cols="12" md="6">
										<v-text-field
											name="address"
											label="Address"
											v-model="organisation.address"
											:rules="addressRules"
											required>
										</v-text-field>
									</v-col>
									<v-col cols="12" md="6">
										<v-text-field
											name="postalCode"
											label="Postal Code"
											v-model="organisation.postalCode"
											:rules="postalCodeRules"
											required>
										</v-text-field>
									</v-col>
								</v-row>
								<v-row>
									<v-col cols="12" md="4">
										<v-autocomplete
											name="county"
											v-model="organisation.countyId"
											:items="county"
											item-text="name"
											item-value='id'
											label="County"
											@change="onCountyChange"
											:error-messages="errors.collect('county')"
										/>
									</v-col>
									<v-col cols="12" md="4">
										<v-autocomplete
											name="subCounty"
											v-model="organisation.subCountyId"
											:items="subcounty"
											item-text="name"
											item-value='id'
											label="Sub County"
											@change="onSubCountyChange"
											:error-messages="errors.collect('subCounty')"
										/>
									</v-col>
									<v-col cols="12" md="4">
										<v-autocomplete
											name="ward"
											v-model="organisation.wardId"
											:items="ward"
											item-text="name"
											item-value='id'
											label="Ward"
											:error-messages="errors.collect('ward')"
										/>
									</v-col>
								</v-row>
								<v-row>
									<v-col cols="12" md="4">
										<v-text-field
											name="village"
											label="Village"
											v-model="organisation.village"
											@keypress="onlyLetters"
											:error-messages="errors.collect('village')">
										</v-text-field>
									</v-col>
									<v-col cols="12" md="4">
										<v-text-field
											name="building"
											label="Building"
											v-model="organisation.building"
											:error-messages="errors.collect('building')">
										</v-text-field>
									</v-col>
									<v-col cols="12" md="4">
										<v-text-field
											name="street"
											label="Street"
											v-model="organisation.street"
											@keypress="onlyAlphaNumeric"
											:error-messages="errors.collect('street')">
										</v-text-field>
									</v-col>
								</v-row>
								<v-row>
									<v-col cols="12" md="4">
										<v-text-field
											name="contactPersonName"
											label="Contact Person Name"
											@keypress="onlyLetters"
											v-model="organisation.contactPersonName"
											:error-messages="errors.collect('contactPersonName')">
										</v-text-field>
									</v-col>
									<v-col cols="12" md="4">
										<v-text-field
											name="contactPersonPhone"
											label="Contact Person Phone"
											v-model="organisation.contactPersonPhone"
											v-validate="'min:9'"
											maxlength="12"
											@keypress="validateContactPersonPhone"
											@paste="handlePasteContactPersonPhone"
											:error-messages="errors.collect('contactPersonPhone')">
										</v-text-field>
									</v-col>
									<v-col cols="12" md="4">
										<v-text-field
											name="contactPersonEmail"
											label="Contact Person Email"
											v-model="organisation.contactPersonEmail"
											v-validate="'email'"
											type="email"
											:error-messages="errors.collect('contactPersonEmail')">
										</v-text-field>
									</v-col>
								</v-row>
								<v-row>
									<v-col cols="12" md="6">
									</v-col>
									<v-col cols="12" md="6">
										<label>Choose Logo
											<input type="file" id="file" accept="image/jpeg" ref="file" v-on:change="handleFileUpload()" />
										</label>
									</v-col>
								</v-row>
								<v-card-actions>
									<v-btn color="primary" @click="closeEditDialog()" rounded>Cancel</v-btn>
									<v-spacer></v-spacer>
									<v-btn color="secondary" @click="e1 = 2" rounded>Next</v-btn>
								</v-card-actions>
							</v-stepper-content>

							<v-stepper-content step="2">
								<!-- Step 2: Non-Checkoff Settlement Details -->
								<v-container grid-list-xl fluid v-if="organisation && organisation.settlement">
									<v-layout wrap>
										<v-flex xs6>
											<v-text-field
												name="accountNumber"
												label="Account No"
												v-model="organisation.account"
												v-validate="'required'"
												:error-messages="errors.collect('accountNumber')">
											</v-text-field>
										</v-flex>
										<v-flex xs6>
											<v-text-field
												name="accountName"
												label="Account Name"
												v-model="organisation.accountName"
												v-validate="'required'"
												:error-messages="errors.collect('accountName')"
												:loading="validatingAccount"
											>
											</v-text-field>
										</v-flex>
										<v-flex xs6>
											<v-autocomplete
												name="bankName"
												v-model="organisation.bankName"
												:items="banks"
												item-text="bankName"
												item-value='bankName'
												label="Bank Name"
												@input="updateSwiftCode"
												v-validate="'required'"
												:error-messages="errors.collect('bankName')"
											>
											</v-autocomplete>
										</v-flex>
										<v-flex xs6>
											<v-text-field
												name="bankSwiftCode"
												label="Bank Swift Code"
												v-model="organisation.bankCode"
												v-validate="'required'"
												:error-messages="errors.collect('bankSwiftCode')"
												disabled
											>
											</v-text-field>
										</v-flex>
										<v-flex xs6>
											<v-autocomplete
												name="currency"
												v-model="organisation.currency"
												:items="currencies"
												label="Currency"
												v-validate="'required'"
												:error-messages="errors.collect('currency')"
											>
											</v-autocomplete>
										</v-flex>
										<v-flex xs12>
											<v-card-actions>
												<v-btn color="primary" @click="e1 = 1" rounded>Back</v-btn>
												<v-spacer></v-spacer>
												<v-btn type="button" color="secondary" @click="updateOrganization" rounded v-if="organisation.organisationTypeId != 4 && organisation.organisationTypeId != 1 && organisation.organisationTypeId != 2 && organisation.organisationTypeId != 3 && organisation.organisationTypeId != 5 && organisation.organisationTypeId != 11" :loading="submitLoading" :disabled="submitLoading">Update</v-btn>
												<v-btn color="primary" @click="e1 = 3" rounded v-if="organisation.organisationTypeId == 4 || organisation.organisationTypeId == 1 || organisation.organisationTypeId == 2 || organisation.organisationTypeId == 3 || organisation.organisationTypeId == 5 || organisation.organisationTypeId == 11">Next</v-btn>
											</v-card-actions>
										</v-flex>
									</v-layout>
								</v-container>
							</v-stepper-content>

							<v-stepper-content step="3">
								<!-- Step 3: Checkoff Settlement Details -->
								<v-container grid-list-xl fluid>
									<v-layout wrap>
										<v-flex xs6>
											<v-text-field
												name="checkoffAccountNumber"
												label="Account No"
												v-model="organisation.checkoffAccountNumber">
											</v-text-field>
										</v-flex>
										<v-flex xs6>
											<v-text-field
												name="checkoffAccountName"
												label="Account Name"
												v-model="organisation.checkoffAccountName"
												:loading="validatingCheckoffAccount"
											>
											</v-text-field>
										</v-flex>
										<v-flex xs6>
											<v-autocomplete
												name="checkoffBankName"
												v-model="organisation.checkoffBankName"
												:items="banks"
												item-text="bankName"
												item-value='bankName'
												label="Bank Name"
												@input="checkoffUpdateSwiftCode">
											</v-autocomplete>
										</v-flex>
										<v-flex xs6>
											<v-text-field
												name="checkoffBankSwiftCode"
												label="Bank Swift Code"
												v-model="organisation.checkoffBankSwiftCode"
												disabled
											>
											</v-text-field>
											<input
												type="hidden"
												name="settlementAccountId"
												v-model="organisation.settlementAccountId"
											/>
										</v-flex>
										<v-flex xs6>
											<v-autocomplete
												name="checkoffCurrency"
												v-model="organisation.checkoffCurrency"
												:items="currencies"
												label="Currency"
											>
											</v-autocomplete>
										</v-flex>
										<v-flex xs6 v-if="organisation.organisationTypeId == 4 || organisation.organisationTypeId == 11">
											<v-autocomplete
												name="broker"
												v-model="selectedBroker"
												:items="brokers"
												item-text="organisationName"
												item-value="id"
												return-object
                                                label="Broker"
												@change="onBrokerSelected">
											</v-autocomplete>
										</v-flex>
										<v-flex xs12 class="text-xs-right" v-if="organisation.organisationTypeId == 4 || organisation.organisationTypeId == 11">
											<v-btn color="primary" @click="addOrganization" rounded>
												Add Details
											</v-btn>
										</v-flex>
										<v-flex xs12 v-if="organisation.organisationTypeId == 4 || organisation.organisationTypeId == 11">
											<table class="details-table">
												<thead>
												<tr>
													<th>Account No</th>
													<th>Account Name</th>
													<th>Bank Name</th>
													<th>Bank Swift C</th>
													<th>Currency</th>
													<th>Broker</th>
													<th></th>
												</tr>
												</thead>
												<tbody>
												<tr v-for="(item, index) in displayGrowerBrokerAccounts" :key="index">
													<td>{{ item.accountNumber }}</td>
													<td>{{ item.accountName }}</td>
													<td>{{ item.bankName }}</td>
													<td>{{ item.swiftCode }}</td>
													<td>{{ item.currency }}</td>
													<td>{{ item.brokerName }}</td>
													<td>
														<button type="button" class="delete-btn" @click="removeBrokerDetails(index)">🗑</button>
													</td>
												</tr>
												</tbody>
											</table>
										</v-flex>
										<v-flex xs12>
											<v-card-actions>
												<v-btn @click="e1 = 2">Back</v-btn>
												<v-spacer></v-spacer>
												<v-btn type="button" color="secondary" @click="updateOrganization" rounded v-if="organisation.organisationTypeId != 4  " :loading="submitLoading" :disabled="submitLoading">Update</v-btn>
												<v-btn color="primary" @click="e1 = 4" rounded v-if="organisation.organisationTypeId == 4 ">Next</v-btn>
											</v-card-actions>
										</v-flex>
									</v-layout>
								</v-container>
							</v-stepper-content>

							<v-stepper-content step="4" v-if="organisation.organisationTypeId == 4">
								<!-- Step 4: Farmer USD Account Details -->
								<v-container grid-list-xl fluid>
									<v-layout wrap>
										<v-flex xs6>
											<v-text-field
												name="farmerUsdAccountNumber"
												label="Account No"
												v-model="organisation.farmerUsdAccountNumber"
												:error-messages="errors.collect('farmerUsdAccountNumber')">
											</v-text-field>
										</v-flex>
										<v-flex xs6>
											<v-text-field
												name="farmerUsdAccountName"
												label="Account Name"
												v-model="organisation.farmerUsdAccountName"
												:error-messages="errors.collect('farmerUsdAccountName')"
											>
											</v-text-field>
										</v-flex>
										<v-flex xs6>
											<v-autocomplete
												name="farmerUsdBankName"
												v-model="organisation.farmerUsdBankName"
												:items="banks"
												item-text="bankName"
												item-value='bankName'
												label="Bank Name"
												@input="farmerUsdUpdateSwiftCode"
												:error-messages="errors.collect('farmerUsdBankName')">
											</v-autocomplete>
										</v-flex>
										<v-flex xs6>
											<v-text-field
												name="farmerUsdBankSwiftCode"
												label="Bank Swift Code"
												v-model="organisation.farmerUsdBankSwiftCode"
												:error-messages="errors.collect('farmerUsdBankSwiftCode')"
												disabled
											>
											</v-text-field>
											<input
												type="hidden"
												name="settlementAccountId"
												v-model="organisation.settlementAccountId"
											/>
										</v-flex>
										<v-flex xs12>
											<v-card-actions>
												<v-btn @click="e1 = 3">Back</v-btn>
												<v-spacer></v-spacer>
												<v-btn color="primary" @click="e1 = 5" rounded>Next</v-btn>
											</v-card-actions>
										</v-flex>
									</v-layout>
								</v-container>
							</v-stepper-content>

							<v-stepper-content step="5" v-if="organisation.organisationTypeId == 4">
								<!-- Step 5: Farmer KES Account Details -->
								<v-container grid-list-xl fluid>
									<v-layout wrap>
										<v-flex xs6>
											<v-text-field
												name="farmerKesAccountNumber"
												label="Account No"
												v-model="organisation.farmerKesAccountNumber"
												:error-messages="errors.collect('farmerKesAccountNumber')">
											</v-text-field>
										</v-flex>
										<v-flex xs6>
											<v-text-field
												name="farmerKesAccountName"
												label="Account Name"
												v-model="organisation.farmerKesAccountName"
												:error-messages="errors.collect('farmerKesAccountName')"
											>
											</v-text-field>
										</v-flex>
										<v-flex xs6>
											<v-autocomplete
												name="farmerKesBankName"
												v-model="organisation.farmerKesBankName"
												:items="banks"
												item-text="bankName"
												item-value='bankName'
												label="Bank Name"
												@input="farmerKesUpdateSwiftCode"
												:error-messages="errors.collect('farmerKesBankName')">
											</v-autocomplete>
										</v-flex>
										<v-flex xs6>
											<v-text-field
												name="farmerKesBankSwiftCode"
												label="Bank Swift Code"
												v-model="organisation.farmerKesBankSwiftCode"
												:error-messages="errors.collect('farmerKesBankSwiftCode')"
												disabled
											>
											</v-text-field>
											<input
												type="hidden"
												name="settlementAccountId"
												v-model="organisation.settlementAccountId"
											/>
										</v-flex>
										<v-flex xs12>
											<v-card-actions>
												<v-btn @click="e1 = 4">Back</v-btn>
												<v-spacer></v-spacer>
												<v-btn type="button" color="secondary" @click="updateOrganization" rounded :loading="submitLoading" :disabled="submitLoading">Update</v-btn>
											</v-card-actions>
										</v-flex>
									</v-layout>
								</v-container>
							</v-stepper-content>
						</v-stepper-items>
					</v-stepper>
				</v-form>
			</v-card-text>
		</v-card>
	</v-dialog>

	</div>
</template>

<script>
import axios from 'axios'
import config from '../../../config'

export default {
	name: 'EditOrganizationForm',
	props: {
		isOpen: Boolean,
		organisation: Object,
		institutionTypes: Array,
		currencies: Array,
		banks: Array,
		county: Array,
		subcounty: Array,
		ward: Array,
		brokers: Array,
		millers: Array,
		warehouse: Array,
		taxtypes: Array,
		farmersocieties: Array,
		growerBrokerAccounts: Array,
		liabilityProviderLoans: Array,
		loading: Boolean,
		submitLoading: Boolean
	},
	data () {
		return {
			editDialog: false,
			valid: true,
			e1: 1,
			isChild: false,
			showCheckbox: false,
			selectedParentOrganisation: null,
			file: null,
			formSubmitting: false,
			validatingAccount: false,
			validatingCheckoffAccount: false,
			checkoffAccountRows: [],
			selectedBroker: null,
			bank: {
				bankName: '',
				bankSwiftCode: '',
				bankCode: '',
				pic: '',
            selectedBroker: null
			},
			organizationNameRules: [
				v => !!v || 'Organization Name is required'
			],
			organizationCodeRules: [
				v => !!v || 'Organization Code is required'
			],
			identificationDocumentIDRules: [
				v => !!v || 'Identification Document Id is required'
			],
			addressRules: [
				v => !!v || 'Address is required'
			],
			postalCodeRules: [
				v => !!v || 'Postal Code is required'
			]
		}
	},
	created () {
		// Initialize settlement object if it doesn't exist
		if (this.organisation && !this.organisation.settlement) {
			this.organisation.settlement = {
				nonCheckoffAccountNumber: '',
				nonCheckoffAccountName: '',
				nonCheckoffBankName: '',
				nonCheckoffSwiftCode: '',
				checkoffCurrency: ''
			}
		}
    console.log('org - ', this.organisation)
		if (this.organisation && !this.organisation.growerBrokerAccounts) {
			this.$set(this.organisation, 'growerBrokerAccounts', [])
		}
		if (this.organisation && Array.isArray(this.organisation.growerBrokerAccounts) && this.organisation.growerBrokerAccounts.length) {
			this.checkoffAccountRows = [...this.organisation.growerBrokerAccounts]
		}
		if (Array.isArray(this.growerBrokerAccounts) && this.growerBrokerAccounts.length) {
			this.checkoffAccountRows = [...this.growerBrokerAccounts]
		}
		if (this.checkoffAccountRows.length) {
			console.log('Initialized checkoffAccountRows with:', this.checkoffAccountRows)
		}
	},
	computed: {
		errors () {
			return (this.$validator && this.$validator.errors) ? this.$validator.errors : {
				collect: () => [],
				has: () => false,
				add: () => {},
				clear: () => {}
			}
		},
		displayGrowerBrokerAccounts () {
			return this.checkoffAccountRows
		}
	},
	watch: {
		isOpen (newVal) {
			this.editDialog = newVal
		},
		editDialog (newVal) {
			if (!newVal) {
				this.handleDialogClose()
			}
		},
		organisation: {
			handler(newVal) {
				if (newVal) {
					// Initialize settlement object if it doesn't exist
					if (!newVal.settlement) {
						this.$set(newVal, 'settlement', {
							nonCheckoffAccountNumber: newVal.account || '',
							nonCheckoffAccountName: newVal.accountName || '',
							nonCheckoffBankName: newVal.bankName || '',
							nonCheckoffSwiftCode: newVal.bankCode || '',
							checkoffCurrency: newVal.currency || ''
						})
					}
					// Initialize county, subcounty, ward if not present
					if (!newVal.county) {
						this.$set(newVal, 'county', null)
					}
					if (!newVal.subcounty) {
						this.$set(newVal, 'subcounty', null)
					}
					if (!newVal.ward) {
						this.$set(newVal, 'ward', null)
					}
					if (!newVal.account && newVal.settlement?.nonCheckoffAccountNumber) {
						this.$set(newVal, 'account', newVal.settlement.nonCheckoffAccountNumber)
					}
					if (!newVal.accountName && newVal.settlement?.nonCheckoffAccountName) {
						this.$set(newVal, 'accountName', newVal.settlement.nonCheckoffAccountName)
					}
					if (!newVal.bankName && newVal.settlement?.nonCheckoffBankName) {
						this.$set(newVal, 'bankName', newVal.settlement.nonCheckoffBankName)
					}
					if (!newVal.bankCode && newVal.settlement?.nonCheckoffSwiftCode) {
						this.$set(newVal, 'bankCode', newVal.settlement.nonCheckoffSwiftCode)
					}
					if (!newVal.currency && newVal.settlement?.checkoffCurrency) {
						if (!newVal.growerBrokerAccounts) {
							this.$set(newVal, 'growerBrokerAccounts', [])
						}
						if (Array.isArray(newVal.growerBrokerAccounts)) {
							this.checkoffAccountRows = [...newVal.growerBrokerAccounts]
						}
						this.$set(newVal, 'currency', newVal.settlement.checkoffCurrency)
					}
					if (Array.isArray(newVal.growerBrokerAccounts)) {
						this.checkoffAccountRows = [...newVal.growerBrokerAccounts]
					}
					if (newVal.county && typeof newVal.county === 'object') {
						this.$set(newVal, 'countyId', newVal.county.id)
					}
					if (newVal.subcounty && typeof newVal.subcounty === 'object') {
						this.$set(newVal, 'subCountyId', newVal.subcounty.id)
					}
					if (newVal.ward && typeof newVal.ward === 'object') {
						this.$set(newVal, 'wardId', newVal.ward.id)
					}

				}
			},
			deep: true
		},
		growerBrokerAccounts: {
			handler(newVal) {
				if (Array.isArray(newVal)) {
					this.checkoffAccountRows = [...newVal]
				} else {
					this.checkoffAccountRows = []
				}
			},
			deep: true,
			immediate: true
		}
	},
	methods: {
		    updateOrganization () {
				console.log('Updating organization with data:', this.growerBrokerAccounts)
			  // Validate form fields using Vuelidate and Vuetify form rules if available
			  const validateForm = () => {
				let valid = true
				if (this.$refs.form) {
					valid = this.$refs.form.validate() && valid
				}
				if (this.$validator && typeof this.$validator.validate === 'function') {
					return this.$validator.validate().then(result => valid && result)
				}
				return Promise.resolve(valid)
			  }

			  validateForm().then(result => {
				if (!result) {
					if (this.$refs.form) {
						this.$refs.form.validate()
					}
					this.showFormError('Please correct the highlighted fields before updating.')
					return
				}

				const parseLiabilityProviderLoans = JSON.stringify(this.liabilityProviderLoans)
				this.organisation.loanDetails = parseLiabilityProviderLoans

				if (this.organisation.countyId && this.organisation.subCountyId && this.organisation.wardId) {
					if (typeof this.organisation.countyId === 'object') {
						this.organisation.countyId = this.organisation.countyId.id
					}
					if (typeof this.organisation.subCountyId === 'object') {
						this.organisation.subCountyId = this.organisation.subCountyId.id
					}
					if (typeof this.organisation.wardId === 'object') {
						this.organisation.wardId = this.organisation.wardId.id
					}
				}

				if (!this.validateAccountNumber(this.organisation.account, this.organisation.checkoffAccountNumber, this.organisation.organisationTypeId)) {
					this.errors.add('accountNumber', 'Checkoff number cannot be 02320750011234 or 02320750031234.')
					return
				}

				if (!this.checkAccountNumber(this.organisation.account, this.organisation.checkoffAccountNumber, this.organisation.organisationTypeId)) {
					this.errors.add('accountNumber', 'Checkoff and noncheckoff accounts cannot be the same or the noncheckoff account cannot be 02320750011234.')
					return
				}

const brokerAccounts = Array.isArray(this.checkoffAccountRows) ? this.checkoffAccountRows : []


				// Map fields to match backend expectations
				const mappedBrokerAccounts = brokerAccounts.map(item => ({
					currency: item.currency,
					brokerId: item.brokerId || item.broker,
					brokerCode: item.brokerCode,
					bankName: item.bankName,
					accountName: item.accountName,
					broker: item.broker,
					accountNo: item.accountNumber || item.accountNo,
					bankSwift: item.swiftCode || item.bankSwift
				}))

				if ((this.organisation.organisationTypeId === 4 || this.organisation.organisationTypeId === 11) && mappedBrokerAccounts.length === 0) {
					this.showFormError('At least one grower broker account is required.')
					return
				}

				let taxtype = this.organisation.tax
				if (Number.isInteger(taxtype)) {
					this.organisation.tax = this.taxtypes.find(t => t.id === taxtype)
				}

				const url = config.serverURI + '/organization/update'
				const formData = new FormData()
				if (this.isChild === false) {
					this.organisation.parent = null
				}

									this.organisation.settlement.nonCheckoffAccountNumber =
    this.organisation.account

this.organisation.settlement.nonCheckoffAccountName =
    this.organisation.accountName

this.organisation.settlement.nonCheckoffBankName =
    this.organisation.bankName

this.organisation.settlement.nonCheckoffSwiftCode =
    this.organisation.bankCode

this.organisation.settlement.nonCheckoffCurrency =
    this.organisation.currency

				const organisationPayload = JSON.parse(JSON.stringify(this.organisation))

				console.log(JSON.stringify(organisationPayload, null, 2))
				if ('growerBrokerAccounts' in organisationPayload) {
					delete organisationPayload.growerBrokerAccounts
				}

				formData.append('file', this.file)
				formData.append('organisation', JSON.stringify(organisationPayload))
				formData.append('checkoffdetails', JSON.stringify(mappedBrokerAccounts))

				this.formSubmitting = true
				axios.post(url, formData)
					.then(response => {
						if (response.data.error) {
							this.showFormError(response.data.message)
						} else {
							this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'primary', message: response.data.message })
							this.$emit('update-complete')
							this.closeEditDialog()
						}
					})
					.catch(error => {
						this.showFormError(error.response?.data?.message || 'Error occurred while updating organization.')
					})
					.finally(() => {
						this.formSubmitting = false
					})
				this.handleFileUpload()
			  })
		  },
		  updateSwiftCode () {
			  // Find the selected bank
			  // const selectedBank = this.banks.find(bank => bank.bankName === this.organisation.settlement.settlementBankName)
const selectedBank = this.banks.find(bank => bank.bankName === this.organisation.bankName)

			  // Update the bank Swift Code
			  if (selectedBank) {
				  this.organisation.bankCode = selectedBank.bankSwiftCode
				  this.bank.bankSwiftCode = selectedBank.bankSwiftCode
				  this.bank.pic = selectedBank.pic
				console.log('selectedBank.bankSwiftCode - ', selectedBank.bankSwiftCode)
				  if (this.bank.pic === '0011') {
					  this.validatingAccount = true
					  const url = config.serverURI + '/organization/validateAccountDetails'
					  // axios.post(url, { accountNumber: this.organisation.settlementAccount })
					  axios.post(url, { accountNumber: this.organisation.account })
						  .then(response => {
							console.log('response - ', response)
							  if (response.data.accountName === null) {
								  this.$emit('show-snackbar', { message: 'Account Details Missing', color: 'error' })
								  this.organisation.accountName = ''
								  console.log('Error is Account Details Missing')
								  return
							  }
							  this.$emit('show-snackbar', { message: 'Account Details validated successfully', color: 'primary' })
							  this.organisation.accountName = response.data.accountName
						  })
						  .catch(error => {
							  console.log('error', error.response)
							  this.$emit('show-snackbar', { message: error.response?.message || 'Error validating account', color: 'error' })
						  })
						  .finally(() => {
							  this.validatingAccount = false
						  })
				  } else {
					  this.validatingAccount = true
					  const url = config.serverURI + '/organization/validateIpslAccountDetails'
					  console.log(this.bank.pic)
					  axios.post(url, { accountNumber: this.organisation.account, pic: this.bank.pic })
						  .then(response => {
							  if (response.data.accountName === null || response.data.accountName === 'Whitelist') {
								  this.$emit('show-snackbar', { message: 'Account Details Missing', color: 'error' })
								  this.organisation.accountName = ''
								  console.log('Error is Account Details Missing')
								  return
							  }
							  this.$emit('show-snackbar', { message: 'Account Details validated successfully', color: 'primary' })
							  this.organisation.accountName = response.data.accountName
						  })
						  .catch(error => {
							  console.log('error', error.response)
							  this.$emit('show-snackbar', { message: error.response?.message || 'Error validating account', color: 'error' })
						  })
						  .finally(() => {
							  this.validatingAccount = false
						  })
				  }
			  } else {
				  this.organisation.bankCode = '' // Reset if the bank is not found
			  }
		  },

		showFormError(message) {
			this.$emit('show-snackbar', { message, color: 'error' })
			console.log('Showing form error:', message)
		},
		handleDialogClose () {
			// Clear any validation errors when dialog closes
			if (this.$validator) {
				this.$validator.reset()
			}
			this.$emit('close')
		},
		closeEditDialog () {
			this.editDialog = false
		},
		handleFileUpload () {
			this.file = this.$refs.file.files[0]
		},
		onlyLetters (event) {
			const char = String.fromCharCode(event.keyCode)
			if (!/^[a-zA-Z\s]*$/.test(char)) {
				event.preventDefault()
			}
		},
		onlyAlphaNumeric (event) {
			const char = String.fromCharCode(event.keyCode)
			if (!/^[a-zA-Z0-9\s]*$/.test(char)) {
				event.preventDefault()
			}
		},
		validateContactPersonPhone (e) {
			const char = String.fromCharCode(e.which || e.keyCode)
			if (!/^[0-9]$/.test(char)) {
				e.preventDefault()
				return
			}
			const value = e.target.value
			if (value.length === 0 && !/[072]/.test(char)) {
				e.preventDefault()
			}
		},
		handlePasteContactPersonPhone (e) {
			const pastedData = (e.clipboardData || window.clipboardData).getData('text')
			if (!/^\d+$/.test(pastedData)) {
				e.preventDefault()
				return
			}
			if (!/^[072]/.test(pastedData)) {
				e.preventDefault()
				return
			}
			const currentValue = this.organisation.contactPersonPhone || ''
			if ((currentValue.length + pastedData.length) > 12) {
				e.preventDefault()
			}
		},
		onParentSelect (selectedOrg) {
			if (selectedOrg) {
				this.organisation.parent = selectedOrg
			} else {
				this.organisation.parentId = null
			}
		},
		searchParentOrganisation (query) {
			if (query && query.length >= 2) {
				this.$emit('search-parent', query)
			}
		},
		onCountyChange () {
			this.$emit('county-change', this.organisation.county)
		},
		onSubCountyChange () {
			this.$emit('subcounty-change', this.organisation.subcounty)
		},
		onBrokerSelected (broker) {
			if (broker) {
				this.selectedBroker = broker
				this.organisation.brokerName = broker.name || broker.organisationName || broker.broker
				this.organisation.brokerId = broker.id || broker.brokerId
				this.organisation.brokerCode = broker.brokerCode || broker.organisationCode || broker.brokerCode
			}
			this.$emit('broker-selected', broker)
		},
		addOrganization () {
			console.log('Settlement checkoff', this.organisation.checkoffAccountNumber)
			console.log('Settlement Account', this.organisation.account)
			if (!this.validateAccountNumber(this.organisation.account, this.organisation.checkoffAccountNumber, this.organisation.organisationTypeId)) {
				this.$emit('show-snackbar', { message: 'Checkoff number cannot be 02320750011234 or 02320750031234.', color: 'error' })
				return
			}
			if (!this.checkAccountNumber(this.organisation.account, this.organisation.checkoffAccountNumber, this.organisation.organisationTypeId)) {
				this.$emit('show-snackbar', { message: 'Checkoff and noncheckoff accounts cannot be the same or the noncheckoff account cannot be 02320750011234.', color: 'error' })
				return
			}

			if (this.organisation.organisationTypeId === 4 || this.organisation.organisationTypeId === 11) {
				const accountNumber = this.organisation.checkoffAccountNumber
				const accountName = this.organisation.checkoffAccountName
				const bankName = this.organisation.checkoffBankName
				const swiftCode = this.organisation.checkoffBankSwiftCode
				const currency = this.organisation.checkoffCurrency
				const brokerName = this.organisation.brokerName
				const brokerId = this.organisation.brokerId
				let brokerCode = this.organisation.brokerCode

				const selectedBroker = this.selectedBroker || this.brokers.find(b => b.id === brokerId || b.brokerId === brokerId)
					if (selectedBroker) {

						console.log('Selected broker:', selectedBroker)
						this.organisation.brokerName = selectedBroker.name || selectedBroker.organisationName || selectedBroker.broker
						this.organisation.brokerId = selectedBroker.id || selectedBroker.brokerId
						this.organisation.brokerCode = selectedBroker.brokerCode || selectedBroker.organisationCode || selectedBroker.brokerCode
						brokerCode = brokerCode || this.organisation.brokerCode
					}
				if (!brokerCode) {
					this.$emit('show-snackbar', { message: 'Please select a broker', color: 'error' })
					return
				}

				if (!this.organisation.growerBrokerAccounts) {
					this.$set(this.organisation, 'growerBrokerAccounts', [])
				}

				const brokerExists = this.organisation.growerBrokerAccounts.some(obj => obj.brokerCode === brokerCode)
				console.log(brokerExists)
				if (brokerExists) {
					this.$emit('show-snackbar', { message: 'The broker already exists', color: 'error' })
					return
				}

				const accountDetails = {
					accountNumber: accountNumber,
					accountName: accountName,
					bankName: bankName,
					swiftCode: swiftCode,
					currency: currency,
					brokerName: brokerName,
					brokerId: brokerId,
					brokerCode: brokerCode
				}

				console.log('Adding account details:', accountDetails)
				this.checkoffAccountRows.push(accountDetails)
				this.organisation.growerBrokerAccounts.push(accountDetails)
				this.$emit('show-snackbar', { message: 'Details added successfully', color: 'primary' })
			}
		},
		removeBrokerDetails (index) {
			if (this.checkoffAccountRows && this.checkoffAccountRows.length > index) {
				this.checkoffAccountRows.splice(index, 1)
			}
			if (this.organisation.growerBrokerAccounts && this.organisation.growerBrokerAccounts.length > index) {
				this.organisation.growerBrokerAccounts.splice(index, 1)
			}
			this.$emit('show-snackbar', { message: 'Details removed successfully', color: 'primary' })
		},
		addLiabilityProviderLoan () {
			this.$emit('add-loan')
		},
		removeLiabilityProviderLoan (index) {
			this.$emit('remove-loan', index)
		},
		checkoffUpdateSwiftCode () {
			const selectedBank = this.banks.find(bank => bank.bankName === this.organisation.checkoffBankName)

			if (selectedBank) {
				this.bank.bankSwiftCode = selectedBank.bankSwiftCode
				this.organisation.checkoffBankSwiftCode = selectedBank.bankSwiftCode
				this.bank.pic = selectedBank.pic
				if (this.bank.pic === '0011') {
					this.validatingCheckoffAccount = true
					const url = config.serverURI + '/organization/validateAccountDetails'
					const data = {
						organisationType: 0,
						accountNumber: this.organisation.checkoffAccountNumber
					}

					axios.post(url, data)
						.then(response => {
							if (response.data.accountName === null) {
								this.$emit('show-snackbar', { message: 'Account Details Missing', color: 'error' })
								this.organisation.checkoffAccountName = ''
								return
							}
							this.$emit('show-snackbar', { message: 'Account Details validated successfully', color: 'primary' })
							this.organisation.checkoffAccountName = response.data.accountName
						})
						.catch(error => {
							this.$emit('show-snackbar', { message: error.response?.message || 'Error validating account', color: 'error' })
						})
						.finally(() => {
							this.validatingCheckoffAccount = false
						})
				} else {
					this.validatingCheckoffAccount = true
					const url = config.serverURI + '/organization/validateIpslAccountDetails'
					axios.post(url, { accountNumber: this.organisation.checkoffAccountNumber, pic: this.bank.pic })
						.then(response => {
							if (response.data.accountName === null || response.data.accountName === 'Whitelist') {
								this.$emit('show-snackbar', { message: 'Account Details Missing', color: 'error' })
								this.organisation.checkoffAccountName = ''
								return
							}
							this.$emit('show-snackbar', { message: 'Account Details validated successfully', color: 'primary' })
							this.organisation.checkoffAccountName = response.data.accountName
						})
						.catch(error => {
							this.$emit('show-snackbar', { message: error.response?.message || 'Error validating account', color: 'error' })
						})
						.finally(() => {
							this.validatingCheckoffAccount = false
						})
				}
			} else {
				this.organisation.checkoffBankSwiftCode = ''
			}
		},
		farmerUsdUpdateSwiftCode () {
			this.$emit('farmer-usd-update-swift-code')
		},
		farmerKesUpdateSwiftCode () {
			this.$emit('farmer-kes-update-swift-code')
		},
		validateAccountNumber (noncheckoff, account, orgType) {
			if (orgType !== 4) {
				if (account !== '02320750011234' && account !== '02320750031234') {
					return true
				} else if (noncheckoff !== '02320750011234' && noncheckoff !== '02320750031234') {
					return true
				} else if (noncheckoff !== '02320750011234') {
					return true
				} else {
					return false
				}
			} else {
				if (account !== '02320750011234' && account !== '02320750031234') {
					return true
				} else if (account !== '02320750011234') {
					return true
				} else {
					return false
				}
			}
		},
		checkAccountNumber (noncheckoff, account, orgType) {
			if (noncheckoff !== '02320750011234') {
				if (account !== noncheckoff) {
					return true
				} else {
					return false
				}
			} else {
				return false
			}
		}
	}
}
</script>

<style scoped>
.details-table {
	width: 100%;
	border-collapse: collapse;
	margin-bottom: 20px;
}

.details-table th,
.details-table td {
	border: 1px solid #ddd;
	padding: 8px;
	text-align: left;
}

.delete-btn {
	background: none;
	border: none;
	cursor: pointer;
	font-size: 18px;
}

.text-xs-right {
	text-align: right !important;
}
</style>
